import {
    _axios as request
} from "../../plugins/axios";

const actions = {
    submitHealthInfo(_, data){
        return new Promise((resolve, reject) => {
            request({
                url: '/user/healthInformation/upload',
                method: 'post',
                data: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    uploadImg(_, data) {
        return new Promise((resolve, reject) => {
            request({
                url: '/file/uploadImg',
                method: 'post',
                data: data,
                // headers: {
                //     'Content-Type': 'multipart/form-data'
                // }
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
};

export default {
    namespaced: true,
    actions,
}
